import React, { useState } from "react";
import './Footer.scss'; // Ensure you create and link a corresponding SCSS file for styling
import { useRouteMatch,Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndConditions from "./TermsandCondition";

const Footer2 = ({homeLogo}) => {
    const history = useHistory()
    const lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "ar"
    const match1 = useRouteMatch("/privacy")
    const match2 = useRouteMatch("/terms")
    const match3 = useRouteMatch("/info")
    const match4 = useRouteMatch("/sorry")
    const [openTerms,setOpenTerms]=useState(false);
    const [openPrivacy,setOpenPrivacy]=useState(false);
    return (
        <>
        <footer className="footer">
        {!(match1 ||  match2 || match3 || match4) ?    <div className="footer-content">
        <div  onClick={()=>history.push("/terms")} className="footer-link">{lang === "en" ? "Terms & Conditions": "والشروط  و الأحكام"}</div>
        <div className="footer-separator"></div>
        <div  onClick={()=>history.push("/privacy")}  className="footer-link"> {lang === "en" ? "Privacy Policy": "سياسة الخصوصية"}</div>
                <div className="footer-separator"></div>
                <a className="footer-link" href ="mailto:contact@telecubesmobile.com"> {lang === "en" ? "Contact Us": "اتصل بنا"}</a>
            </div> :""}
            <div className="footer-copy">
                {lang === "en" ?" Copyright © 2024 CubeGames Telecubes Mobile. All Rights Reserved.": "حقوق الطبع والنشر © 2024 CubeGames Telecubes Mobile. كل الحقوق "}
            </div>
        </footer>
        {openPrivacy && <PrivacyPolicy setOpenPrivacy={setOpenPrivacy} openPrivacy={openPrivacy} selectedLang={lang} homeLogo={homeLogo}/>}
        {openTerms && <TermsAndConditions setOpenTerms={setOpenTerms} openTerms={openTerms} selectedLang={lang} homeLogo={homeLogo}/>}
        </>
    );
}

export default Footer2;
